import {
	Component,
	OnInit,
	Injector,
	Input,
	ElementRef,
	ViewContainerRef,
	ViewChild,
	OnChanges,
	AfterViewInit,
} from '@angular/core';
import { BaseComponent } from '../../base.component';
import { isEmpty, forEach } from 'lodash';
import { AddressesService } from '../../../Services/addresses/Addresses';
import { fail } from 'assert';

@Component({
	selector: 'address',
	host: { '[class]': 'myCustomClass' },
	template: `
		<div class="address-wrapper">
			<div
				*ngIf="control && control.withNoQuestion && error"
				class="withNoQuestionError-container"
				id="error-container"
			>
				<div class="error">
					<i class="error-icon"></i>
					{{ error }}
				</div>
			</div>

			<toggle-visible
				[hidden]="!addressesService.isOpen"
				[isOpen]="addressesService.isOpen"
				(focusLost)="closePopOver()"
				(closeOnClick)="closePopOver()"
			>
				<popover-address
					(onAddressSelect)="onAddressSelect($event)"
					[addresses]="addressesService.autocompleteAddresses"
					[suggestedOnInit]="control.attributes.addressSuggestionOnInit"
					(close)="isOpen()"
					[changeTitle]="control.withNoQuestion"
				></popover-address>
			</toggle-visible>

			<div>
				<address-subcontrol
					context="page"
					*ngFor="let child of control.controls"
					[control]="child"
					[parentControl]="control"
					[name]="child.name"
					[ngClass]="{
						'small-margin': control.controlType === 'AddressChange',
						'bundle-btn': control.name === 'ButtonLink.BackToBundle'
					}"
				>
				</address-subcontrol>
			</div>

			<div class="google-maps" tabIndex="-1" [ngClass]="{ 'full-width': !control.title }">
				<map
					[address]="fullAddress"
					[mapVisible]="isVisible('map')"
					[streetViewVisible]="isVisible('streetView')"
				></map>
			</div>
		</div>
	`,
	styleUrls: ['./address.component.scss'],
})
export class AddressComponent extends BaseComponent implements OnInit, AfterViewInit {
	children: any;
	fullAddress: FullAddress;
	manualWrite: boolean;
	SuggestedOnInit: boolean;
	addressChangedControl: any;
	autocompleteAddresses: any;
	isAddressOpen: boolean;
	allCities: any;
	isError: boolean;

	constructor(injector: Injector, private Addresses: AddressesService) {
		super(injector);
	}

	get addressesService(): AddressesService {
		return this.Addresses;
	}

	ngOnInit() {
		this.SuggestedOnInit = false;
		this.isAddressOpen = false;
		this.children = {};
		this.Addresses.El = this.elementRef;
		this.observablesService.addressChanged.subscribe((res) => {
			this.observablesService.AddressError = res.isError;
		});

		if (this.control && this.control.withNoQuestion) {
			this.observablesService.pageUpdated.subscribe((action) => {
				//update errors for address component only when withNoquestion is true(in mpq3 dr)
				this.error = this.storeService.getError(this.control, this.context);
				if (!this.error && this.control && this.control.controls) {
					const errors = this.control.controls.map((c) => this.storeService.getError(c, this.context)).filter((e) => e);
					if (errors && errors.length) {
						this.error = errors[0];
					}
				}
			});
		}

		// Run once
		this.Addresses.getFullAddress(this.control);
		this.initControls();
		if (!isEmpty(this.control.attributes)) {
			// Get Address Suggestion on init

			if (
				this.control.attributes.addressSuggestionOnInit &&
				this.layoutresolver.staticContentModel.data.addonParams.dataLayerParams.bundledquote[0] === 'Y'
			) {
				// if attribute addressSuggestionOnInit = true && flow is MPQ3
				this.Addresses.getAddressSuggestions(this.control, true);
			}
			// Call CityStateZip on init
			if (
				this.control.attributes.zipCodeOnInit &&
				!this.observablesService.AddressError &&
				this.layoutresolver.staticContentModel.data.addonParams.dataLayerParams.bundledquote[0] === 'Y'
			) {
				this.Addresses.onZipChange(this.control, this.fullAddress.zipCode, true);
			}
		}

		this.isError = false;
		this.initInnerVisibilitySub();
	}

	ngAfterViewInit() {
		this.initInnerVisibilitySub();
	}

	isVisible(element) {
		if (!this.control.attributes[element].visible) {
			return false;
		}

		const { address1, city, state, zipCode } = this.Addresses.fullAddress;

		if (!address1 || !city || !state || !zipCode) {
			return false;
		}

		return true;
	}

	initInnerVisibilitySub(): void {
		this.Addresses.showEditAddressReplaySubject.subscribe((isShow: boolean) => {
			const elem = this.elementRef.nativeElement.parentElement.parentElement.parentElement.parentElement;
			if (isShow) {
				this.Renderer.setStyle(elem, 'display', 'block');
			} else {
				this.Renderer.setStyle(elem, 'display', 'none');
			}
		});
	}

	isOpen() {
		this.Addresses.isOpen = false;
		this.isAddressOpen = false;
	}

	// getFullAddress() {
	//     this.fullAddress = Object.assign({},{
	//         address1: this.storeService.updateData(`${this.control.name}.AddressLine1`,'', 'page'),
	//         address2: this.storeService.updateData(`${this.control.name}.AddressLine2`,'', 'page'),
	//         city: this.storeService.updateData(`${this.control.name}.City`,'', 'page'),
	//         state: this.storeService.updateData(`${this.control.name}.State`,'', 'page'),
	//         county: this.storeService.updateData(`${this.control.name}.County`, '','page'),
	//         zipCode: this.storeService.updateData(`${this.control.name}.ZipCode`,'', 'page'),
	//         longtitude: this.storeService.updateData(`${this.control.name}.Longtitude`,'', 'page'),
	//         latitude: this.storeService.updateData(`${this.control.name}.Latitude`,'', 'page'),
	//     });
	// }

	initControls() {
		const currentCity = String(this.storeService.getValue(`${this.control.name}.City`, 'page')).toUpperCase();
		// this.storeService.updateData(`${this.control.name}.City`, currentCity, 'page');

		const cityOptions = [];

		if (currentCity) {
			cityOptions.push({
				title: currentCity,
				image: null,
				value: currentCity,
				sequence: 0,
			});
		}
		this.storeService.updateControlAttributes(
			`${this.control.name}.City`,
			'page',
			{ options: cityOptions, disabled: true },
			`${this.control.name}`
		);

		// fetch full address when zip is provided, but city or state are not
		const { zipCode, city, state, longtitude, latitude } = (this.fullAddress = this.Addresses.fullAddress);

		if (zipCode && (!city || !state) && !this.observablesService.AddressError) {
			this.Addresses.onZipChange(this.control, zipCode, false);
		}
	}

	closePopOver() {
		if (this.Addresses.autocompleteAddresses) {
			this.Addresses.isOpen = false;
		}
	}

	onAddressSelect(addressContainer, isinit = false) {
		const address = addressContainer.address;
		if (!isinit) {
			if (isEmpty(this.allCities)) {
				this.allCities = [];
			}
			if (this.allCities.indexOf(address.City) === -1) {
				this.allCities.push(address.City);
				this.allCities.sort();
			}

			// Sometimes the addres does not appear in the
			// initial cities list in the city dropdown. If so,
			// replace city options with the returned city

			this.storeService.updateData(`${this.control.name}.AddressLine1`, address.AddressLine1, 'page');
			this.storeService.updateData(`${this.control.name}.City`, address.City, 'page');
			this.storeService.updateData(`${this.control.name}.State`, address.State, 'page');
			this.storeService.updateData(`${this.control.name}.ZipCode`, address.ZipCode, 'page');
			this.storeService.updateData(`${this.control.name}.County`, address.County, 'page');
			this.manualWrite = true;
			this.storeService.updateControlAttributes(
				`${this.control.name}.City`,
				'page',
				{
					disabled: true,
				},
				this.control.name
			);
		}
		this.storeService.updateData(`${this.control.name}.Longtitude`, address.Longtitude, 'page');
		this.storeService.updateData(`${this.control.name}.Latitude`, address.Latitude, 'page');

		this.Addresses.getFullAddress(this.control);
		this.control.id = Object.assign('', this.control.id);
	}
}
